let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bLzp5")).then(() => parcelRequire('1Ba8D'));